// src/services/api.js
import axios from 'axios';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const api = axios.create({
  //baseURL: process.env.REACT_APP_API_URL || 'http://186.0.180.65:8000',
   baseURL: process.env.REACT_APP_API_URL || ''
});

api.interceptors.request.use((config) => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user?.token) {
      config.headers = config.headers || {};
      config.headers['Authorization'] = `Bearer ${user.token}`;
    }
  } catch {
    // Ignorar errores de parseo JSON y enviar petición sin header
  }
  return config;
});

// --- INICIO INTERCEPTOR DE RESPUESTAS MODIFICADO ---
api.interceptors.response.use(
  (response) => {
    // Cualquier código de estado que se encuentre dentro del rango de 2xx causa que esta función se active
    return response;
  },
  (error) => {
    // Cualquier código de estado que caiga fuera del rango de 2xx causa que esta función se active
    if (error.response && error.response.status === 401) {
      console.error("API_SERVICE: Error 401 - No Autorizado. Token inválido o expirado.");
      localStorage.removeItem('user'); // Limpiar datos de usuario del localStorage

      // Forzar redirección a la página de login si no estamos ya ahí.
      // Asegúrate de que la ruta '/' es tu página de login.
      if (window.location.pathname !== '/' && window.location.pathname !== '/login') { // Ajusta '/login' si tu ruta es diferente
        window.location.href = '/'; // Redirige a la raíz (página de login)
      }
    }
    return Promise.reject(error); // Propagar el error para que sea manejado por el .catch() de la llamada original
  }
);
// --- FIN INTERCEPTOR DE RESPUESTAS MODIFICADO ---

export const login = (username, password) => {
  const form = new URLSearchParams();
  form.append('username', username);
  form.append('password', password);
  return api.post('/login', form);
};

export const getEPG = (file) =>
  api.get('/epg', { params: { file } });

export const getTemplate = (file) => api.get('/template', { params: { file } });

export const saveTemplate = (file, programmes) => api.post('/template', { file, programmes });

export const getTemplateStatus = (file) => api.get('/template/status', { params: { file } });

export const applyTemplate = (file, targetMonday, mode) =>
  api.post('/template/apply', { file, target_monday: targetMonday, mode });

export const saveEPG = (file, programmesFromGrid) => {
  console.log("API_SERVICE: saveEPG llamado con:", programmesFromGrid.length, "programas");

  const programmesForBackend = programmesFromGrid.map(prog => {
    const { start: startStr, duration: durationStr, title, channel, desc, __internalId } = prog;

    const startDayjs = dayjs(startStr, "YYYY/MM/DD HH:mm:ss", true);

    if (!startDayjs.isValid()) {
      console.error(`API_SERVICE: Formato de 'start' inválido para "${title}" (ID: ${__internalId}): ${startStr}`);
      return {
        title,
        channel: channel || "UnknownChannel", // Asegurar que channel tenga un valor
        desc: desc || "",
        start: "INVALID_DATE", // Marcar como inválido
        stop: "INVALID_DATE",
        error_processing: `Invalid start date: ${startStr}`
      };
    }

    let durationMinutes = 0;
    if (typeof durationStr === 'string' && durationStr.includes(':')) {
      const parts = durationStr.split(':').map(Number);
      if (parts.length >= 2 && !isNaN(parts[0]) && !isNaN(parts[1])) {
        durationMinutes = (parts[0] * 60) + parts[1];
      } else {
        console.error(`API_SERVICE: Formato de 'duration' inválido para "${title}" (ID: ${__internalId}): ${durationStr}`);
      }
    } else {
       console.error(`API_SERVICE: Formato de 'duration' inesperado para "${title}" (ID: ${__internalId}): ${durationStr}`);
    }

    if (durationMinutes <= 0) {
        console.warn(`API_SERVICE: Duración es cero o negativa para "${title}" (ID: ${__internalId}): ${durationMinutes} mins. Se usará 1 min por defecto.`);
        durationMinutes = 1;
    }

    const stopDayjs = startDayjs.add(durationMinutes, 'minute');
    const backendStartFormat = startDayjs.format("YYYYMMDDHHmmss");
    const backendStopFormat = stopDayjs.format("YYYYMMDDHHmmss");

    return {
      title: title,
      channel: channel || "UnknownChannel", // Asegurar que channel tenga un valor
      desc: desc || "",
      start: backendStartFormat,
      stop: backendStopFormat,
    };
  });

  // Filtrar programas que tuvieron error de procesamiento de fecha para no enviarlos mal al backend
  const validProgrammesForBackend = programmesForBackend.filter(p => !p.error_processing);
  if (validProgrammesForBackend.length !== programmesForBackend.length) {
      console.warn("API_SERVICE: Algunos programas fueron omitidos debido a errores de procesamiento de fecha/duración.");
  }

  console.log("API_SERVICE: Payload que se enviará al backend:", { file, programmes: validProgrammesForBackend });
  return api.post('/epg', { file, programmes: validProgrammesForBackend });
};
